import { apiForPrivate } from '.';
import { TRUSTED_DRIVER_ENDPOINT } from '../../config/ap';

const apiCourts = apiForPrivate.injectEndpoints({
    overrideExisting: true,
    endpoints: build => ({
        getCourtClient: build.query({
            query: id => `${TRUSTED_DRIVER_ENDPOINT.CLIENTS}/${id}/court-clients`
        }),
        saveCourtClient: build.mutation({
            query: ({clientId, payload}) => ({
                url: `${TRUSTED_DRIVER_ENDPOINT.CLIENTS}/${clientId}/court-clients`,
                method: 'POST',
                body: payload,
            }),
        }),
    })
});

export const {
    useLazyGetCourtClientQuery,
    useSaveCourtClientMutation
} = apiCourts;
